import styled from "styled-components";
import { Button } from "antd";

export const SubmitButton = styled(Button)`
  &.btn-submit[disabled],
  &.btn-submit[aria-disabled="true"] {
    background: #e7e7e7 !important;
    border-color: #e7e7e7 !important;
    color: #fff !important;
    cursor: not-allowed !important;
  }
`;
// Priority label styled components
export const PriorityLabelRed = styled.span`
  color: #ff4d4d;
`;
export const PriorityLabelOrange = styled.span`
  color: #ffa500;
`;
export const PriorityLabelYellow = styled.span`
  color: #ffd700;
`;
export const PriorityLabelGreen = styled.span`
  color: #32cd32;
`;

// User name styled
export const UserName = styled.span`
  color: #000000d9;
  margin-right: 6px;
`;

// File tag styled
export const FileTag = styled.span`
  background: #eee;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  max-width: 120px;

  .file-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
  }
`;

export const RemoveFile = styled.span`
  cursor: pointer;
  color: #ff4d4f;
  font-weight: bold;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  &:hover {
    background: #ff4d4f22;
  }
`;

export const TooltipFileList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 250px;
  overflow-y: auto;
  padding: 4px;

  /* Custom scrollbar for better look in tooltip */
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 4px;
  }
`;

export const TooltipFileTag = styled(FileTag)`
  max-width: none;
  width: 100%;
  background: #f0f2f5 !important;
  border: 1px solid #d9d9d9;
`;

export const EllipsisBadge = styled.span`
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  color: #1e3666;
  display: flex;
  align-items: center;
  padding: 0 8px;
  background: #eee;
  border-radius: 4px;
  height: 24px;
  margin-left: 2px;
  transition: all 0.2s;
  &:hover {
    background: #e0e0e0;
    color: #15264d;
  }
`;

export const StyledChat = styled.div<{
  $isFullscreen?: boolean;
  $hasFiles?: boolean;
}>`
  height: 100%;
  ${(props) =>
    props.$isFullscreen &&
    `
    form {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
  `}
  .chat-header {
    margin: -24px -24px 0px -24px;
    box-shadow: 0px 2px 8px 0px #00000014;
    padding: 6px 12px;
    &__noti {
      display: flex;
      column-gap: 12px;
      align-items: center;
      overflow: hidden;
      p:first-child {
        color: #191919;
        font-size: 12px;
        flex-shrink: 0;
      }
      .chat-header__title-wrapper {
        flex: 1;
        min-width: 0;
        display: flex;
      }
      .chat-header__noti-title {
        font-weight: 500;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1;
        min-width: 0;
      }
    }
    &__info,
    .chat-header-admin__info {
      display: flex;
      font-size: 12px;
      color: #989ca6;
      align-items: center;
      /* margin-bottom: 8px; */
      img {
        margin-right: 4px;
      }
      p:nth-child(3) {
        width: 1px;
        height: 24px;
        border-right: 1px solid #e8eaee;
        margin: 0 12px;
      }
    }
    .chat-header-admin {
      &__title-wrapper {
        flex: 1;
        min-width: 0;
        display: flex;
        /* margin-bottom: 8px; */
        overflow: hidden;
      }
      &__title {
        font-weight: 700;
        margin-bottom: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1;
        min-width: 0;
      }
      &__info {
        p:nth-child(2) {
          width: 410px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .select-custom {
        width: 88px !important;
        font-size: 12px;
        .ant-select-selector {
          height: 22px;
          .ant-select-selection-item {
            line-height: 22px;
            font-size: 12px;
          }
        }
        .ant-select-arrow {
          color: #8c8c8c;
        }
      }
      .line-vertical {
        height: 12px !important;
      }
      .form-item-custom {
        margin-bottom: 0;
        .ant-row {
          align-items: center;
          label {
            color: #999faa;
            font-size: 12px;
          }
        }

        label {
          min-width: 73px;
        }

        &__label {
          label {
            min-width: 100px;
          }
        }
      }
      &__row {
        height: 30px;
        display: flex;
        font-size: 12px;
        column-gap: 24px;
        align-items: center;
        .ant-row {
          label {
            color: #000000d9 !important;
          }
        }
      }
    }
    &__status {
      min-height: 22px;
      display: flex;
      align-items: center;
    }
  }
  .chat-content {
    ${(props) => (props.$isFullscreen ? "flex: 1;" : "height: 377px;")}
  }
  .chat-content-admin {
    ${(props) => (props.$isFullscreen ? "flex: 1;" : "height: 287px;")}
  }
  .chat-content,
  .chat-content-admin {
    padding: 24px 24px;
    margin: 0 -24px;
    overflow-y: scroll;
    &__item {
      display: flex;
      column-gap: 10px;
      margin: 0px -24px;
      padding: 0px 12px;
      margin-bottom: 12px;
      .message {
        border: 1px solid #00000026;
        padding: 8px;
        border-radius: 8px;
        max-width: ${(props) => (props.$isFullscreen ? "70%" : "298px")};
        p:first-child {
          display: flex;
          align-items: center;
          span:first-child {
            font-size: 14px;
            font-weight: 600;
          }
          span:last-child {
            white-space: pre-wrap;
            word-break: break-word;
            color: #8c8c8c;
            font-size: 12px;
          }
        }
        &[data-created-by]:not([data-created-by=""]) p:first-child {
          column-gap: 12px;
        }
        .message-content:nth-child(2) {
          width: 100%;
          /* margin-top: 10px; */
          white-space: pre-line;
          word-break: break-word;
        }
        .message-content {
          width: 100%;
          /* margin-top: 10px; */
          white-space: pre-line;
          word-break: break-word;
        }
        .ai-message-plain-text {
          display: block;
          width: 100%;
          white-space: pre-line;
          overflow-wrap: anywhere;
          word-break: break-word;
        }
        .ai-structured-message {
          width: 100%;
          white-space: normal;
          overflow-wrap: anywhere;
          word-break: break-word;

          .ai-message-heading,
          h4 {
            margin: 0 0 6px;
            font-size: 13px;
            font-weight: 600;
          }

          h4 {
            margin-top: 8px;
          }

          .ai-message-summary {
            display: block;
            margin: 0 0 8px;
            white-space: pre-line;
            overflow-wrap: anywhere;
            word-break: break-word;
          }

          .ai-message-steps,
          .ai-message-notes {
            margin: 0;
            padding-left: 20px;
          }

          .ai-message-steps li,
          .ai-message-notes li {
            margin-bottom: 4px;
            overflow-wrap: anywhere;
            word-break: break-word;
          }

          .ai-message-step-text,
          .ai-message-note-text {
            white-space: pre-line;
            overflow-wrap: anywhere;
            word-break: break-word;
          }

          .ai-message-navigation-link {
            color: #1890ff;
            text-decoration: underline;
            overflow-wrap: anywhere;
            word-break: break-word;
          }
        }
        .del-message {
          display: flex;
          justify-content: end;
          img {
            cursor: pointer;
          }
        }
      }
    }
    &__itemSend {
      justify-content: end;
      .message {
        background: #e6f7ff;
        border: 1px solid #bae7ff;
      }
    }

    &__itemAi {
      .message {
        background: #f4f1ff;
        border-color: #d9d0ff;
      }

      .message-sender-ai {
        color: #4d368f;
      }

      .message-ai-badge {
        display: inline-flex;
        align-items: center;
        min-height: 20px;
        padding: 0 6px;
        border-radius: 10px;
        background: #e5ddff;
        color: #4d368f;
        font-size: 11px;
        font-weight: 600;
        white-space: nowrap;
      }
    }
  }

  .chat-ai-avatar {
    width: 28px;
    height: 28px;
    flex: 0 0 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #6d56b4;
    color: #fff;
    font-size: 18px;
  }

  .chat-ai-status {
    display: flex;
    align-items: center;
    column-gap: 8px;
    width: fit-content;
    max-width: 100%;
    margin: 4px 0 12px;
    padding: 8px 12px;
    border: 1px solid #d9d0ff;
    border-radius: 8px;
    background: #faf9ff;
    color: #4d368f;
    font-size: 12px;
    overflow-wrap: anywhere;
  }

  .chat-ai-status--terminal {
    border-color: #e4e4e4;
    background: #fafafa;
    color: #666;
  }

  .response-mode-control__label {
    min-width: 92px;
  }

  .response-mode-control {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;

    &__label {
      color: #000000d9;
      font-size: 12px;
      white-space: nowrap;
    }
  }
  .chat-footer {
    padding: 8px 12px 12px 12px;
    box-shadow: 0px -2px 8px 0px #00000014;
    margin: 0px -24px -24px -24px;
    &__form {
      display: flex;
      column-gap: 16px;
      .btn-upload {
        display: flex;
        align-items: center;
        height: ${(props) => (props.$hasFiles ? "52px" : "74px")};
        width: 44px;
        justify-content: center;
        border: 1px dashed #00000026;
        border-radius: 8px;
        .attach-icon {
          font-size: 16px;
          color: #000000;
          transform: rotate(45deg);
        }
      }
      .form-message {
        width: 100%;
        .inp-message {
          border-radius: 8px;
          resize: none;
        }
        .file-list {
          margin-top: 4px;
          display: flex;
          gap: 4px;
          flex-wrap: wrap;
          min-height: 24px;
        }
      }
    }
    .btn-submit {
      background: #1e3666;
      width: 100%;
      height: 40px;
      border-radius: 6px;
      margin-top: ${(props) => (props.$hasFiles ? "10px" : "16px")};
    }
  }

  .chat-image-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    max-width: 100%;
    margin-top: 6px;
    margin-bottom: 6px;
  }

  .chat-image,
  .chat-video {
    max-width: min(100%, 360px);
    max-height: 280px;
    border-radius: 6px;
    object-fit: contain;
  }

  .chat-video {
    background: #000;
  }

  /* .chat-header-admin-timer {
    margin-top: 2px;
  } */

  .chat-time {
    color: #989ca6;
    font-size: 12px;
    min-width: 152px;
  }

  .chat-time-line {
    border-right: 1px solid #e8eaee;
    height: 12px;
  }

  @media (max-width: 640px) {
    .chat-header-admin__row {
      flex-wrap: wrap;
      height: auto;
      row-gap: 6px;
    }

    .chat-content,
    .chat-content-admin {
      padding-left: 12px;
      padding-right: 12px;

      &__item {
        margin-left: -12px;
        margin-right: -12px;
        padding-left: 8px;
        padding-right: 8px;

        .message {
          max-width: calc(100% - 38px);
        }
      }
    }

    .chat-ai-status {
      width: auto;
    }
  }
`;
